<template>
    <layout title="Suchergebnisse" :banner="$page.props.banner" h1="Suchergebnisse">

        <section id="searchresults" class="scol-section py-6">
            <div class="container">
                <div class="row">
                    <div class="col-lg-4 mb-4 mb-lg-0" id="searchfilter">
                        <form @submit.prevent="searchTravel()">
                            <div class="search-filter">
                                <h2 class="h6 bg-primary text-white p-3 m-0">
                                    Suche
                                </h2>
                            </div>
                            <div class="bg-light-grey p-3">
                                <div class="ort">
                                    <div class="row">
                                        <div class="item-headline mb-2">
                                            <i class="fas fa-mountain me-1"></i>Ort
                                        </div>
                                    </div>
                                    <div>
                                        <div>
                                            <locations v-model:search="form.l" input-class="rounded-0 border-0" v-model:code="form.code" :locations="searchLocations" />
                                        </div>
                                    </div>
                                    <div class="row my-2">
                                        <div class="col-12"><hr></div>
                                    </div>
                                </div>

                                <div class="Zeitraum">
                                    <div class="row">
                                        <div class="item-headline mb-2">
                                            <i class="fas fa-calendar-alt me-2"></i>Zeitraum
                                        </div>
                                    </div>
                                    <div>
                                        <div>
                                            <div>
                                                <Datepicker v-model="form.r" inputClassName="form-control rounded-0 border-0" range placeholder="Reisezeitraum (Winter)..." locale="de-DE" :format="datepickerFormat" multi-calendars auto-apply :enable-time-picker="false" :min-date="seasonStart" :max-date="seasonEnd" :start-date="seasonStart" :markers="markers" prevent-min-max-navigation />
                                                <small class="d-block text-muted mt-1 search-date-legend">
                                                    <span class="legend-dot legend-dot--arrival"></span> Anreise
                                                    <span class="legend-dot legend-dot--departure ms-2"></span> Abreise
                                                    <span class="legend-dot legend-dot--both ms-2"></span> beides
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row my-2">
                                        <div class="col-12"><hr></div>
                                    </div>
                                </div>

                                <div class="personen">
                                    <div class="row">
                                        <div class="item-headline mb-2">
                                            <i class="fas fa-user-friends me-1"></i>Personen/Zimmer
                                        </div>
                                    </div>
                                    <div>
                                        <div>
                                            <ul class="list-unstyled mb-0 bg-white p-2">
                                                <li class="d-flex justify-content-between align-items-center mb-3">
                                                    <span>Erwachsene</span>
                                                    <span class="d-flex align-items-center">
                                                        <button type="button" class="btn btn-sm btn-link btn-item-no-margin p-0" @click="removeAdult" :disabled="!form.p.a"><i class="bi bi-dash-circle"></i></button>
                                                        <span class="text-center mx-2">{{ form.p.a }}</span>
                                                        <button type="button" class="btn btn-sm btn-link btn-item-no-margin p-0" @click="addAdult" :disabled="form.p.a == maxAdults"><i class="bi bi-plus-circle"></i></button>
                                                    </span>
                                                </li>
                                                <li class="d-flex justify-content-between align-items-center mb-3">
                                                    <span class="lh-1">Kinder<br><small class="text-muted">bis 18 Jahre</small></span>
                                                    <span class="d-flex align-items-center">
                                                        <button type="button" class="btn btn-sm btn-link btn-item-no-margin p-0" @click="removeChild" :disabled="!form.p.c"><i class="bi bi-dash-circle"></i></button>
                                                        <span class="text-center mx-2">{{ form.p.c }}</span>
                                                        <button type="button" class="btn btn-sm btn-link btn-item-no-margin p-0" @click="addChild" :disabled="form.p.c == maxChilds"><i class="bi bi-plus-circle"></i></button>
                                                    </span>
                                                </li>
                                                <li class="d-flex justify-content-between align-items-center">
                                                    <span>Zimmer</span>
                                                    <span class="d-flex align-items-center">
                                                        <button type="button" class="btn btn-sm btn-link btn-item-no-margin p-0" @click="removeRoom" :disabled="form.z < 2"><i class="bi bi-dash-circle"></i></button>
                                                        <span class="text-center mx-2">{{ form.z }}</span>
                                                        <button type="button" class="btn btn-sm btn-link btn-item-no-margin p-0" @click="addRoom" :disabled="form.z == maxRooms"><i class="bi bi-plus-circle"></i></button>
                                                    </span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                             <div class="bg-light-grey text-end pb-3 px-3">
                                <button v-if="form.isDirty" type="submit" class="btn btn-primary btn-sm rounded-pill"><i class="fa-solid fa-arrows-rotate"></i>Aktualisieren</button>
                            </div>
                        </form>
                    </div>
                    <div class="col-lg-8">
                        <div id="search-results">
                            <div class="row row-cols-1 row-cols-md-2 g-4" v-if="Object.keys(this.travelDates).length">
                                <div class="col" v-for="tDate in travelDates" :key="'travel-dates-' + tDate.id">
                                    <travel-date :model="tDate" />
                                </div>
                            </div>
                            <div v-else class="alert alert-info mt-3 rounded-0 text-center">
                                Wir konnten keine passende Reise finden, die deiner Suche entspricht.<br>Bitte versuche es noch einmal.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </layout>
</template>

<script>
import Layout from "./Layouts/Standard";
import { Inertia } from "@inertiajs/inertia";
import { useForm, usePage } from "@inertiajs/inertia-vue3";
import Datepicker from "@vuepic/vue-datepicker";
import { Carousel, Slide, Navigation } from "vue3-carousel";
import TravelDate from "../Components/Scol/TravelDate";
import Locations from "../Components/Scol/Locations";
import ScolSearch from "../Models/Search";


export default {
    components: {
        Layout,
        Carousel,
        Slide,
        Navigation,
        TravelDate,
        Locations,
        Datepicker,
    },
    props: {
        searchLocations: Object,
        travelDates: Object,
        // An-/Abreise-Marker für den Kalender (kommen aus dem PageController).
        searchMarkers: {
            type: Array,
            default: () => [],
        },
    },
    data: () => ({
        showPersons: false,
        maxAdults: 10,
        maxChilds: 10,
        maxRooms: 10,
        // Wintersaison 26/27: nur dieser Zeitraum ist im Kalender wählbar.
        // (Monat ist 0-basiert: 11 = Dezember, 3 = April.)
        seasonStart: new Date(2026, 11, 5), // 05.12.2026
        seasonEnd: new Date(2027, 3, 3), // 03.04.2027
        form: useForm(ScolSearch.defaults()),
        info: {
            itemsToShow: 2,
            snapAlign: "start",
            breakpoints: {
                700: {
                    itemsToShow: 2,
                    snapAlign: "start",
                },
                1024: {
                    itemsToShow: 2,
                    snapAlign: "start",
                },
            },
        },
        galerie: {
            itemsToShow: 3,
            wrapAround: true,
            snapAlign: "start",
            arrows: true,
        },
        edit: {
            location: false,
            range: false,
            persons: false,
        },
        search: null,
    }),
    watch: {
        form: {
            handler(value) {
                const data = {
                    l: value.l,
                    r: value.r,
                    p: value.p,
                    ages: value.ages,
                    tid: value.tid,
                    code: value.code,
                    z: Math.min(value.z, value.p.a),
                };
                this.form.z = data.z;
                // ScolSearch.putSessionStorage(data);
                this.search.data = data;
                this.search.toStorage();
            },
            deep: true,
        },
    },
    // TODO: Watcher reset location on type
    methods: {
        searchTravel() {
            this.form.get(this.$route("search-results"), {
                preserveScroll: true,
                onSuccess: () => this.form.reset("location"),
            });
        },
        togglePersons() {
            this.showPersons = !this.showPersons;
        },
        addAdult() {
            if (this.form.p.a == this.maxAdults) {
                return;
            }
            this.form.p.a++;
        },
        removeAdult() {
            if (this.form.p.a == 1) {
                return;
            }
            this.form.p.a--;
        },
        addChild() {
            if (this.form.p.c == this.maxChilds) {
                return;
            }
            this.form.p.c++;
        },
        removeChild() {
            if (!this.form.p.c) {
                return;
            }
            this.form.p.c--;
        },
        addRoom() {
            if (this.form.z == this.form.p.a || this.form.z == this.maxRooms) {
                return;
            }
            this.form.z++;
        },
        removeRoom() {
            if (this.form.z == 1) {
                return;
            }
            this.form.z--;
        },
        toggleEdit(name) {
            this.edit[name] = !this.edit[name];

            //   if (!this.edit[name]) {

            //     this.form.get(this.$route("search-results"), {
            //       // preserveScroll: true,
            //     //   onSuccess: () => this.form.reset("location"),
            //     });
            //   }
        },
        datepickerFormat: (range) => {
            //   console.log(range[0], range[1]);
            const options = { weekday: "short", month: "short", day: "numeric" };
            const date1 = new Date(range[0]);
            const from =
                date1.toLocaleDateString("de-DE", { weekday: "short" }) +
                ", " +
                date1.toLocaleDateString("de-DE", { month: "short", day: "numeric" });
            const date2 = new Date(range[1]);
            const to =
                date2.toLocaleDateString("de-DE", { weekday: "short" }) +
                ", " +
                date2.toLocaleDateString("de-DE", { month: "short", day: "numeric" });
            return `${from} - ${to}`;
        },
    },
    mounted() {
        this.search = new ScolSearch().fromStorage();
        const form = this.search.data;
        if (form && form.l) {
            this.form.l = form.l;
        }
        if (form && form.r) {
            this.form.r = form.r;
        }
        if (form && form.p) {
            this.form.p = form.p;
        }
        if (form && form.ages) {
            this.form.ages = form.ages;
        }
        if (form && form.tid) {
            this.form.tid = form.tid;
        }
        if (form && form.code) {
            this.form.code = form.code;
        }
        if (form && form.z) {
            this.form.z = form.z;
        }
        this.form.defaults().reset();
    },
    computed: {
        // vue-datepicker erwartet Date-Objekte für die Marker-Daten.
        markers() {
            return this.searchMarkers.map((marker) => ({
                ...marker,
                date: new Date(marker.date),
            }));
        },
        personsValue() {
            let value = "";
            if (this.form.p.a) {
                value +=
                    this.form.p.a +
                    " " +
                    (this.form.p.a == 1 ? "Erwachsener" : "Erwachsene");
            }
            if (this.form.p.a && this.form.p.c) {
                value += ", ";
            }
            if (this.form.p.c) {
                value += this.form.p.c + " " + (this.form.p.c == 1 ? "Kind" : "Kinder");
            }
            return value;
        },
    },
};
</script>

<style scoped>
.search-date-legend {
  font-size: 0.75rem;
}
.legend-dot {
  display: inline-block;
  width: 0.55rem;
  height: 0.55rem;
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 0.2rem;
}
.legend-dot--arrival {
  background-color: #198754;
}
.legend-dot--departure {
  background-color: #dc3545;
}
.legend-dot--both {
  background-color: #fd7e14;
}
</style>
